import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import axios from "axios";
import { GET_GENERAL_PAGES } from "../../config/ApisCollection";

export default function Menu() {
  const dispatch = useDispatch();
  const [generalData, setGeneralData] = useState(null);

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(35));
  };

  const GetGeneralPages = async () => {
    const get_header = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    await axios
      .post(GET_GENERAL_PAGES, { country: "us" }, get_header)
      .then((response) => {
        setGeneralData(response.data);
      });
  };

  useEffect(() => {
    GetGeneralPages();
  }, []);

  return (
    <div className="w-full h-full relatsive">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="flex flex-col text-left gap-2 mt-6 w-11/12 mx-auto pb-14">
        {generalData != null ? (
          <>
            <h1 className="font-bold text-3xl pb-2">Refund policy</h1>
            <div
              dangerouslySetInnerHTML={{ __html: generalData[7].description }}
            ></div>
          </>
        ) : (
          <div className="flex justify-center">Loading...</div>
        )}
      </div>
      {/* <div className="w-full h-52 absolute bottom-0 left-0 right-0 bg-gradient-to-t from-white to-transparent" /> */}
    </div>
  );
}
